module.exports = __webpack_public_path__ + "static/media/ethnicity-uc.9230c05e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/ethnicity-uc.svg
// module id = 364
// module chunks = 0